export function getDownload(fileName, url, setLoading, isSuccess) {
    setLoading(true);
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true); // 也可用POST方式
    xhr.responseType = "blob";
    xhr.onload = function () {
        if (this.status === 200) {
            var blob = this.response;
            if (navigator.msSaveBlob == null) {
                var a = document.createElement("a");
                a.download = fileName;
                a.href = URL.createObjectURL(blob);
                $("body").append(a);
                a.click();
                URL.revokeObjectURL(a.href);
                $(a).remove();
            } else {
                navigator.msSaveBlob(blob, fileName);
            }
            isSuccess && isSuccess(true);
        } else {
            isSuccess && isSuccess(false);
        }
        setLoading(false);
    };
    xhr.send();
}

export function getQueryParameters(url) {
    const queryParams = {};
    const queryString = url.split("?")[1];

    if (queryString) {
        const pairs = queryString.split("&");
        pairs.forEach((pair) => {
            const [key, value] = pair.split("=");
            queryParams[key] = decodeURIComponent(value);
        });
    }

    return queryParams;
}

export function getCurrentQuery() {
    const params = new URLSearchParams(window.location.search);
    let query = {};
    for (const param of params) {
        query[param[0]] = param[1];
    }

    // if (query.redirectUrl) {
    // 	let path = ''
    // 	for (let i = 0; i < HASH_QUERY.length; i++) {
    // 		if (query.redirectUrl.includes(HASH_QUERY[i])) {
    // 			path = HASH_QUERY[i]
    // 		}
    // 	}

    // 	if (!!path) {
    // 		const redirect = query.redirectUrl.split(path)
    // 		query.redirectUrl = redirect[0] + path + '/#' + redirect[1]
    // 	}
    // }
    return query;
}

export function getBrowserType() {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf("Chrome") !== -1) {
        return "GoogleChrome";
    } else if (userAgent.indexOf("Firefox") !== -1) {
        return "MozillaFirefox";
    } else if (userAgent.indexOf("Safari") !== -1) {
        return "AppleSafari";
    } else if (userAgent.indexOf("Opera") !== -1) {
        return "Opera";
    } else if (userAgent.indexOf("Edge") !== -1) {
        return "MicrosoftEdge";
    } else if (userAgent.indexOf("Trident") !== -1) {
        return "InternetExplorer";
    } else {
        return "Unknown";
    }
}

async function convertImageToBase64(imagePath) {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export async function loadImageToBase64(img) {
    const imagePath = img;
    const base64 = await convertImageToBase64(imagePath);
    return base64;
}

export function whiteList(url) {
    let whiteLists = [
        "toca.17u.cn",
        "wiki.17u.cn",
        "note.17u.cn",
        "toca.qa.17u.cn",
        "wiki.qa.17u.cn",
        "note.qa.17u.cn",
        "toca.t.17u.cn",
        "wiki.t.17u.cn",
        "note.t.17u.cn"
    ];

    for (let index = 0; index < whiteLists.length; index++) {
        const key = whiteLists[index];
        if (url.indexOf(key) > -1) {
            return true;
        }
    }

    return false;
}

export function isValid(url) {
    let allowSchemes = ["http", "https"];

    for (let index = 0; index < allowSchemes.length; index++) {
        const scheme = allowSchemes[index];
        if (url.startsWith(scheme)) {
            return true;
        }
    }
    return false;
}

export function replaceXssUrl(url) {
    if (isValid(url)) {
        return url;
    } else {
        return "";
    }
}
